"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleStopPropagationNnofullscreen = void 0;

//阻止事件并禁止视频全屏
var handleStopPropagationNnofullscreen = function handleStopPropagationNnofullscreen() {
  var ckeIframeDocument, imgNode, videoNode, videoContainer;
  setTimeout(function () {
    ckeIframeDocument = document.getElementsByClassName("cke_wysiwyg_frame")[0].contentWindow.document;
    imgNode = ckeIframeDocument.getElementsByTagName("img");
    videoNode = ckeIframeDocument.getElementsByTagName("video");
    videoContainer = ckeIframeDocument.getElementsByClassName("ckeditor-html5-video");

    for (var i = 0; i < imgNode.length; i++) {
      imgNode[i].addEventListener("dblclick", function (e) {
        e.stopPropagation();
      });
    }

    for (var _i = 0; _i < videoNode.length; _i++) {
      videoNode[_i].setAttribute("controlsList", "nofullscreen");
    }

    for (var _i2 = 0; _i2 < videoContainer.length; _i2++) {
      videoContainer[_i2].addEventListener("dblclick", function (e) {
        e.stopPropagation();
      });
    }
  }, 100);
};

exports.handleStopPropagationNnofullscreen = handleStopPropagationNnofullscreen;